import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";
import CustomerDetail from "views/Details/Index";
import Loans from "../Loans/Loans";
import CustomerDocuments from "../Documents/CustomerDocuments";
import Credit from "../Credit/Credit";
import Comments from "views/Comments/Comments";
import Installment from "views/Installment/Installment.js";
import Legal from "views/Customer/Legal";
import Communication from "views/Customer/Communication.js";
import LspProvidedJson from "views/Customer/LspProvidedJson";
import getPrivilegeList from "../../PrivilegeList";

// Complete customer detail: all sections (customer, leads, documents, credit, installment, legal,
// etc.) render stacked on one scrollable page; the sidebar scrolls to the chosen section.
const MasterScroll = () => {
  const privilegeList = getPrivilegeList();

  // All sections always render (single-scroll view); the sidebar just scrolls to them.
  const show = () => true;

  return (
    <div className="bg-lighter" style={{ padding: "24px 20px 100px 20px" }}>

      {privilegeList.detailShow && show("section-customer") && (
        <section id="section-customer">
          <CustomerDetail />
        </section>
      )}

      {privilegeList.loanTabShow && show("section-leads") && (
        <section id="section-leads">
          <Loans />
        </section>
      )}

      {/* Comments section hidden from the customer view */}
      {false && privilegeList.commentTabShow && show("section-comments") && (
        <section id="section-comments">
          <Comments />
        </section>
      )}

      {privilegeList.creditTabShow && show("section-credit") && (
        <section id="section-credit">
          <Credit />
        </section>
      )}

      {/* Standalone Installment section hidden — it now lives inside the Lead card's Installment tab. */}
      {false && privilegeList.installmentTabShow && show("section-installment") && (
        <section id="section-installment">
          <Installment />
        </section>
      )}

      {/* Documents placed just above Legal */}
      {privilegeList.documentTabShow && show("section-documents") && (
        <section id="section-documents">
          <CustomerDocuments />
        </section>
      )}

      {privilegeList.legalTabShow && show("section-legal") && (
        <section id="section-legal">
          <Legal />
        </section>
      )}

      {privilegeList.communicationLogTabShow && show("section-communication-log") && (
        <section id="section-communication-log">
          <Communication />
        </section>
      )}

      {/* JSON — customer view only (payment view keeps it hidden). */}
      {show("section-json") && (
        <section id="section-json">
          <Card className="shadow">
            <CardHeader className="bg-white border-0">
              <h3 className="mb-0">JSON</h3>
            </CardHeader>
            <CardBody className="bg-secondary">
              <LspProvidedJson />
            </CardBody>
          </Card>
        </section>
      )}
    </div>
  );
};

export default MasterScroll;
